export default __webpack_public_path__ + "static/media/6_banner-software-testes.7e67c5cf.jpg";